import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useBlocker } from "react-router-dom";
import { ReactComponent as Logo } from "../../../../.MODULS/UCAT_EXAM_MODUL/Assests/download-min.svg";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
// import { listPracticeTest } from "../../../../Redux/Slices/PracticeTest/ListPracticeTestSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { clearlistStudentExam } from "../../../../Redux/Slices/StudentExam/ListStudentExamSlice";
import {
  listPracticeExamID,
  clearListPracticeExamID,
} from "../../../../Redux/Slices/PracticeExam/ListPracticeExamIDSlice";
import {
  listReExamPracticeID,
  clearListReExamPracticeID,
} from "../../../../Redux/Slices/ReExamPractice/ListReExamPracticeSlice";
import { pendingPracticeExam } from "../../../../Redux/Slices/PendingPracticeExam/PendingPracticeExamSlice";
import { listInstructionPracticeExamID } from "../../../../Redux/Slices/PracticeExam/ListinstructionPracticeExamIDSlice";
import { UcatLayout, UcatModal } from "../../Components/Shared";
import { ReloadWarningModal } from "../../Components/Practice_Test/Exam_component";
import useNavigationBlocker from "../../../../Hooks/useNavigationBlocker";
import QuestionMarkIcon from "../../Assests/green_question_mark.png"

/* ================== STATIC DATA ================== */
// export const UCAT_WELCOME_DATA = {
//   examBrand: {
//     short: "UCAT",
//     full: "University Clinical Aptitude Test",
//   },
//   content: {
//     title: "Welcome to the UCAT Practice Questions",

//   },
// };

/* ================== COMPONENT ================== */
interface UcatTestInstructionsProps {
  examData?: {
    id: number;
    name: string;
    description: string;
  };
}

// props are optional
export const UcatTestInstructions: React.FC<UcatTestInstructionsProps> = ({ examData: propsExamData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  useNavigationBlocker(true);
  const dispatch = useAppDispatch();
  const examDataFromState = location.state;

  // Persist state to handle reloads
  useEffect(() => {
    if (examDataFromState && typeof examDataFromState === 'object') {
      sessionStorage.setItem("ucat_instruction_state", JSON.stringify(examDataFromState));
    }
  }, [examDataFromState]);

  const persistedStateStr = sessionStorage.getItem("ucat_instruction_state");
  const persistedState = persistedStateStr ? JSON.parse(persistedStateStr) : null;
  const activeState = (examDataFromState && typeof examDataFromState === 'object') ? examDataFromState : persistedState;

  const exam_id = activeState?.exam_id || activeState?.id || (typeof examDataFromState === 'number' || typeof examDataFromState === 'string' ? examDataFromState : null);
  const student_test_id = activeState?.student_test_id || (activeState?.id ? activeState.id : null);
  const subtype_instructions = activeState?.subtype_instructions;
  const subtype_name = activeState?.subtype_name;
  const subtype_flag = activeState?.subtype_flag;
  const questionIndex = activeState?.questionIndex;
  const isReturningFromSubtype = activeState?.isReturningFromSubtype;
  const subtype_index = activeState?.subtype_index;

  // Navigation blocker state
  const [showReloadWarning, setShowReloadWarning] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const blockerInitializedRef = useRef(false);

  // Navigation blocker implementation
  const blocker = useBlocker(
    ({ currentLocation, nextLocation, historyAction }) => {
      // Prevent multiple blocker initializations
      if (!blockerInitializedRef.current) {
        blockerInitializedRef.current = true;
      }

      // 1. ALWAYS block browser back/forward buttons (POP)
      if (historyAction === "POP") {
        console.log("🚫 Blocking browser arrow navigation in instructions");
        return true;
      }

      // 2. Allow if we are explicitly submitting/skipping
      if (isSubmittingRef.current) {
        console.log("✅ Allowing navigation (submitting/skipping)");
        return false;
      }

      // 3. Allow if the path isn't changing
      if (currentLocation.pathname === nextLocation.pathname) {
        return false;
      }

      // 4. Only allow navigation to ucat_test_screen, ucat_pending_test_screen and practicetest
      const allowedPaths = ["/ucat_test_screen", "/ucat_pending_test_screen", "/practicetest", "/ucat_retake_test_screen"];
      const isAllowedTarget = allowedPaths.includes(nextLocation.pathname);

      console.warn("INSTRUCTIONS BLOCKER", nextLocation.pathname);
      return !isAllowedTarget;
    }
  );

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowReloadWarning(true);
    } else {
      setShowReloadWarning(false);
    }
  }, [blocker.state]);

  // Cleanup blocker when component unmounts
  useEffect(() => {
    return () => {
      setShowReloadWarning(false);
      if (blocker.state === "blocked") {
        blocker.reset();
      }
    };
  }, [blocker]);

  const handleReloadConfirm = () => {
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setShowReloadWarning(false);

    if (blocker.state === "blocked") {
      blocker.reset();
    }

    navigate('/practicetest');
  };

  const handleReloadCancel = () => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    setShowReloadWarning(false);
  };

  // const [openDialog, setOpenDialog] = useState(false);

  console.log("exam_idXX1", exam_id)

  // Get data from Redux
  const { data: listPracticeExamIDData, isLoading: isPracticeExamIDLoading } = useAppSelector(
    (state) => state.ListPracticeExamIDSlice
  );

  const { data: listPracticeExams, isLoading: isPracticeExamsLoading } = useAppSelector(
    (state) => state.ListPracticeTestSlice
  );

  const { data: pendingPracticeExamData, isLoading: isPendingPracticeExamLoading } = useAppSelector(
    (state) => state.PendingPracticeExamSlice
  );

  const { data: listReExamPracticeIDSlice, isLoading: isReExamPracticeIDLoading } = useAppSelector(
    (state) => state.ListReExamPracticeIDSlice
  );

  // Fetch exam instruction data on mount
  useEffect(() => {
    dispatch(clearlistStudentExam()); // Clear stale student exam data
    dispatch(clearListPracticeExamID()); // Clear stale practice exam ID data
    dispatch(clearListReExamPracticeID());

    const examMode = sessionStorage.getItem("ucat_exam_mode");

    if (student_test_id) {
      if (examMode === "pending") {
        dispatch(pendingPracticeExam({ id: Number(student_test_id) }));
      } else if (examMode === "retake") {
        dispatch(listReExamPracticeID({
          student_test_id: Number(student_test_id),
          client_tz_offset: new Date().getTimezoneOffset() * -1 // standard way if offsetMinutes not available
        }));
      } else {
        dispatch(listPracticeExamID({ student_test_id: Number(student_test_id) }));
      }
    }
    if (exam_id) {
      dispatch(listInstructionPracticeExamID({ test_id: Number(exam_id) }));
    }
  }, [dispatch, student_test_id, exam_id]);

  const [newStudentTestId, setNewStudentTestId] = useState<number | null>(null);

  // Trigger Start Test API after Retake Success
  useEffect(() => {
    const examMode = sessionStorage.getItem("ucat_exam_mode");
    if (examMode === "retake") {
      const rawReExamData: any = (listReExamPracticeIDSlice as any)?.data || listReExamPracticeIDSlice;
      const reExamData = Array.isArray(rawReExamData) ? rawReExamData[0] : rawReExamData;

      if (reExamData?.id || reExamData?.student_test_id) {
        const newId = reExamData.id || reExamData.student_test_id;
        if (newId !== newStudentTestId) {
          setNewStudentTestId(newId);
          dispatch(listPracticeExamID({ student_test_id: Number(newId) }));
        }
      }
    }
  }, [listReExamPracticeIDSlice, dispatch, newStudentTestId]);

  // Local variables for fetched data
  const examMode = sessionStorage.getItem("ucat_exam_mode");
  const sliceData: any = (examMode === "retake" && !listPracticeExamIDData)
    ? listReExamPracticeIDSlice
    : (examMode === "pending")
      ? pendingPracticeExamData
      : listPracticeExamIDData;

  // Extremely robust normalization: handle [obj], {data: [obj]}, {data: obj}, or obj
  const rawPracticeExamData = sliceData?.data || sliceData;
  const practiceExamData = Array.isArray(rawPracticeExamData) ? rawPracticeExamData[0] : rawPracticeExamData;

  console.log("practiceExamData Resolved:", practiceExamData)

  // Use ID from response if available (especially for retake which might create a new ID)
  const resolvedStudentTestId = newStudentTestId || practiceExamData?.student_test_id || practiceExamData?.id || student_test_id;

  const examName = practiceExamData?.test_name || practiceExamData?.exam_name || "";

  // Calculate subtype_index if not provided in state
  const calculatedSubtypeIndex = examDataFromState?.subtype_index ??
    (() => {
      if (!subtype_name || !practiceExamData?.question_by_type) return 0;

      for (const section of practiceExamData.question_by_type) {
        if ((section as any).subtype_data) {
          const foundIndex = (section as any).subtype_data.findIndex(
            (subtype: any) => subtype.subtype_name === subtype_name || subtype.subtype_id === examDataFromState?.subtype_id
          );
          if (foundIndex !== -1) return foundIndex;
        }
      }
      return 0;
    })();

  const subtypes = (practiceExamData?.question_by_type || []).flatMap((item: any) =>
    item.has_subtype ? (item.subtype_data || []) : [{}]
  );
  const hasSubtypes = subtypes?.some((subtype: any) => subtype?.subtype_name);


  const examData =
    propsExamData ||
    (typeof examDataFromState === "object" ? examDataFromState : null) ||
    (Array.isArray(listPracticeExams?.data)
      ? listPracticeExams?.data.find((exam: any) => exam.id === exam_id)
      : null);

  const { data: listInstructionPracticeExamSlice, isLoading: isInstructionLoading } = useAppSelector(
    (state) => state.ListInstructionPracticeExamSlice
  ) as { data?: any, isLoading: boolean };
  const ListInstructionPracticeExamSlices: any =
    listInstructionPracticeExamSlice?.data;

  const ListInstructionPracticeExam =
    ListInstructionPracticeExamSlices?.test_instructions;

  console.log("examDataXX1", examData);
  console.log("practiceExamData", practiceExamData);

  const handleNext = () => {
    isSubmittingRef.current = true;
    const examMode = sessionStorage.getItem("ucat_exam_mode");
    const targetPath = examMode === "pending"
      ? "/ucat_pending_test_screen"
      : examMode === "retake"
        ? "/ucat_retake_test_screen"
        : "/ucat_test_screen";

    navigate(targetPath, {
      state: {
        student_test_id: resolvedStudentTestId, // Using the resolved ID
        questionIndex: questionIndex ?? 0,
        subtype_id: examDataFromState?.subtype_id,
      },
    });
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    // Only handle Alt key combinations
    if (e.altKey) {
      const key = e.key.toLowerCase();

      // Prevent default browser behavior
      e.preventDefault();



      // Main screen context
      switch (key) {
        case 'e':
          // End exam action
          navigate("/practicetest");
          break;
        case 'n':
          handleNext();
          break;
      }
    }
  }


  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Re-bind when dialog state changes

  // const handleConfirmNo = () => {
  //   setOpenDialog(false);
  // };
  // Show loading state while fetching data
  const isLoading = isPracticeExamIDLoading || isPracticeExamsLoading || isPendingPracticeExamLoading || isReExamPracticeIDLoading || isInstructionLoading;

  if (isLoading || !exam_id) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <CircularProgress />

      </div>
    );
  }

  // Get the first section name or use exam name as header title
  // const headerTitle = examData?.questions_by_type?.[0]?.question_type_name || examData?.exam_name || "UCAT Practice";
  // const subTitle = examData?.exam_name || "";
  // get alternative data from props
  const headerTitle = examName || examData?.name || "UCAT Practice";
  const subTitle = examData?.description || "";

  console.log("exam dataYYY", examData, practiceExamData, ListInstructionPracticeExam)
  // console.log("headerTitle22", headerTitle);
  // console.log("subTitle22", subTitle);

  return (
    <UcatLayout
      headerTitle={headerTitle}
      showToolbar={true}
      isLoading={isLoading}
      footerProps={{
        onEndExam: () => navigate("/practicetest"),
        onNext: handleNext,
        leftButtonText: "End Exam",
        rightButtonText: "Next"
      }}
    >
      {/* ================= CONTENT ================= */}
      <div className="flex-1 overflow-y-auto ucat-scrollbar min-h-0">
        <div className="ucat-module font-[15px] max-w-[100%] mx-auto px-4 py-4">
          {/* Logo */}
          {/* <div className="flex justify-end mb-3">
            <Logo className="w-[456px] h-auto" />
          </div> */}

          {/* Text Content */}
          <div className="space-y-4 text-[14px] text-black max-w-full">
            <div>
              {!subtype_flag ? (
                <h1 className="flex text-[16px] font-[700] mb-3">
                  {(subtype_instructions ? (subtype_name || "").toUpperCase() : (examName || examData?.name || "").toUpperCase()) + " PRACTICE QUESTIONS"}
                </h1>
              ) : (
                <p className="flex text-[16px] font-[400] mb-3">
                  {`Section ${calculatedSubtypeIndex + 1} - ${subtype_name || ""}`}
                </p>
              )}

              {!subtype_flag && ListInstructionPracticeExam && (
                <div className="text-[15px] font-[400]">
                  <ul style={{
                    listStyleType: "disc",
                    marginLeft: "4rem",
                    fontSize: "15px",
                  }}>
                    {Array.isArray(ListInstructionPracticeExam) ?
                      ListInstructionPracticeExam.map((item: any, idx: number) => (
                        item[0] == '*' ?
                          <li key={idx} style={{ fontSize: "15px" }}>
                            {typeof item === 'object' && item.instruction ? item.instruction :
                              typeof item === 'string' ? item :
                                JSON.stringify(item.slice(1,))}
                          </li>
                          :
                          <p key={idx} style={{ fontSize: "15px" }}>
                            {typeof item === 'object' && item.instruction ? item.instruction :
                              typeof item === 'string' ? item :
                                JSON.stringify(item)}
                            <br /><br />
                          </p>
                      )) :
                      typeof ListInstructionPracticeExam === 'object' && ListInstructionPracticeExam.instruction ?
                        <li style={{ fontSize: "15px" }}>{ListInstructionPracticeExam.instruction}</li> :
                        typeof ListInstructionPracticeExam === 'string' ?
                          <li style={{ fontSize: "15px" }}>{ListInstructionPracticeExam}</li> :
                          null
                    }
                    <br />
                  </ul>
                </div>
              )}

              <br />
              <div className="text-[15px] font-[400]">
                {subtype_instructions ? (
                  <ul style={{
                    listStyleType: "disc",
                    paddingLeft: "1.5rem",
                    marginLeft: "4rem",
                    fontSize: "15px",
                  }}>
                    {subtype_instructions?.map((inst: string, idx: number) => (
                      <li key={idx} style={{ fontSize: "15px" }}>{inst}</li>
                    ))}
                    <br />
                  </ul>
                ) : (
                  <>
                    {hasSubtypes && (
                      <p style={{ fontSize: "15px" }}>
                        This practice test contains:
                        <br /><br />
                      </p>
                    )}
                    {hasSubtypes && (
                      <ul style={{
                        listStyleType: "disc",
                        paddingLeft: "1.5rem",
                        marginLeft: "4rem",
                        fontSize: "15px",
                      }}>
                        {subtypes?.map((subtype: any, index: number) => (
                          subtype?.subtype_name ? (
                            <li key={subtype.subtype_id || index} style={{ fontSize: "15px" }}>{examName || examData?.name}  -  {subtype.subtype_name}</li>
                          ) : null
                        ))}
                        <br />
                      </ul>
                    )}
                  </>
                )}
              </div>
            </div>

            <p className="text-[15px]">Click the <b style={{ fontSize: "inherit" }}>Next (N)</b> button to proceed.</p>
          </div>
        </div>
      </div>

      {/* ================= CONFIRMATION DIALOG ================= */}
      {/* refactr UCATDialog later */}

      <ReloadWarningModal
        isOpen={showReloadWarning}
        onClose={handleReloadCancel}
        onConfirm={handleReloadConfirm}
      />

    </UcatLayout>
  );
};
